export const menuList = [
    {
        id: 1,
        path: "/",
        label: "Home"
    },
    {
        id: 2,
        path: "/about",
        label: "About"
    },
    {
        id: 3,
        path: "/service",
        label: "Service"
    },
    {
        id: 4,
        path: "/works",
        label: "Works"
    },
    {
        id: 5,
        path: "/contact",
        label: "Contact"
    },

]